/**
 * admin_user_status_controller.js — Admin > user detail > Suspend / Activate (Stimulus).
 *
 * Confirms, posts the user's toggle-status route, toasts the answer and
 * re-renders the page in place through window.chippiePageCheck.refresh(). The
 * route answers JSON to a plain fetch (the Users list's row forms ask it for
 * a Turbo Stream instead), and the detail page draws the status in several
 * places, so the server's render of the whole page is what shows the change.
 *
 * Values: url (the toggle-status route). Params on the button: name, active
 * (the user's status before the change).
 *
 * Template: templates/admin/user_detail.html
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { url: String };

    toggle(event) {
        const { name, active } = event.params;
        const verb = active ? 'Suspend' : 'Activate';
        if (!confirm(`${verb} user ${name}?`)) return;

        fetch(this.urlValue, { method: 'POST', credentials: 'same-origin' })
            .then(function (response) { return response.json(); })
            .then(function (data) {
                if (!data.success) throw new Error(data.message || 'Unknown error');
                window.showNotification(active ? `Suspended ${name}` : `Activated ${name}`, 'success');
                window.chippiePageCheck.refresh();
            })
            .catch(function (error) {
                window.showNotification('Failed to update user status: ' + error.message, 'error');
            });
    }
}
